import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../services/shared-data.service';
import { CpLoaderService } from 'src/app/services/cp-loader.service';

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss']
})
export class LoadingBarComponent implements OnInit {
  display: Boolean = false;

  constructor(
    private loaderService: CpLoaderService
  ) { }

  ngOnInit() {
    this.loaderService.isLoading.subscribe((value) => {
      // Below setTimeout function is used to prevent the Angular error 
      // "Expression has changed after it was checked". This error occurs when the value of the 
      // 'display' variable is changed multiple times before the angular life cycle is completed.
      // More details about the error are mentioned here:
      // https://blog.angular-university.io/angular-debugging/
      setTimeout(() => {
        this.display = value;
      }, 0)
    });
  }
}
